import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { triggerInterruptNotification, searchInterruptNotifications } from '@src/services/HeliosInterruptService'

/**
 * Listens for heliosInterrupt requests and forwards them to the heliosInterruptService.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'trigger', 'search'
 *          parameters: {object} - object containing the parameters for the CrossFrame call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function heliosInterruptListener (message: any) {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {

    case 'trigger':
        console.log('ATBase: HeliosInterruptListener triggered with action trigger, params:', params)
    /**
     * Calls atInterrupt for a given notification.
     * Clears the snoozed notification and timer, if they exist.
     */
        return Promise.resolve(triggerInterruptNotification(params, params))

    case 'search':
        console.log('ATBase: HeliosInterruptListener triggered with action search, params:', params)
    /**
     * Searches device notifications for a HELIOS-type to interrupt on. Checks that the notification hasn't already interrupted before, and adds to list of interrupted notifs.
     */
        return Promise.resolve(searchInterruptNotifications(params))
    }

    console.log('ATBase: HeliosInterruptListener triggered with action unsupported: ' + action)
    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
